import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';
import type { MayBe } from 'modules/global/typing/common/common';
import { canAccessTo } from 'modules/users/selectors/currentUser';

import type { RootState } from 'reducers/index';
import { getRoot } from 'utils/selectors';

import type { StoredAudit } from '../types/stored-audit';

const getState = (state: RootState) => state.audit.all;

export const getId = (_: unknown, id: string) => id;

const getAll = createSelector(getState, state => state.byId);

export const getError = createSelector(getState, state => state.apiError);

export const isLoading = createSelector(getState, state => state.isLoading);

// Generic so the call site narrows to the projection it expects; defaults to the stored detail shape.
// (rule 10 §4 — the `as unknown as` cast preserves reselect memoization while adding the type param.)
export const getDataById = createSelector(getAll, getId, (all, id) => all?.[id]) as unknown as
  <T = StoredAudit>(state: RootState, id: MayBe<string>) => T;

const formatCollection = (state: RootState, ids?: string[]): MayBe<StoredAudit[]> =>
  ids?.map(id => getDataById(state, id));

export const getByIds = createSelector(formatCollection, items => items) as unknown as
  <T = StoredAudit>(state: RootState, ids?: string[]) => T[];

export const canAccessToAudit = createSelector(getRoot, () => PATH.AUDITS.path, canAccessTo);
